import classNames from "classnames";
import styles from "./Tab.module.scss";

export const Tab = ({ value, index, onClick, className, children }) => (
  <button
    type="button"
    className={classNames(className, styles.root, { [styles.active]: value === index })}
    onClick={() => onClick(index)}
  >
    {children}
  </button>
);
